import './footer.css';

interface FooterProps {
  lang: string;
}

export const Footer: React.FC<FooterProps> = () => {
  return (
    <footer id="footer" className="site-footer">
      <hr />

      <div className="container">
        <img
          width="128"
          src="/img/lftr-bn.png"
          alt="LIFTER Studio Logo"
        />

        <p>© 2025–2026 LIFTER Studio</p>

        <a
          href="mailto:hello@lifter.studio"
          className="footer-email"
        >
          hello@lifter.studio
        </a>
      </div>
    </footer>
  );
};
